import type { TonyteActivity } from '../types';

// "Top Picks for You" sits after this many regular event cards — close to the
// top of the list, so the personalised module isn't easy to miss below the
// fold. 2 still divides evenly into 1 and 2 grid columns; on the 3-column
// desktop layout the module simply lands after the first (partial) row
// rather than mid-row, which reads fine since it's already a full-width
// break in the grid.
export const TOP_PICKS_AFTER_CARDS = 2;

export type FeedRow =
  | { type: 'cards'; key: string; items: TonyteActivity[] }
  | { type: 'topPicks'; key: 'top-picks' };

// Lays the (already filtered and sorted) regular feed out as rows — one card per
// row on mobile, `columns` cards per row on wide web — and splices the
// full-width "Top Picks for You" slot in after the first group of cards. A
// FlatList with numColumns > 1 can't hold a full-width item mid-grid, hence
// rows. Every event in `items` appears exactly once, in order: the carousel is
// a discovery surface and never takes anything out of the regular list.
export function buildFeedRows(
  items: TonyteActivity[],
  columns: number,
  showTopPicksSlot: boolean,
  insertAfter: number = TOP_PICKS_AFTER_CARDS,
): FeedRow[] {
  const rows: FeedRow[] = [];
  const pushCards = (group: TonyteActivity[]) => {
    for (let i = 0; i < group.length; i += columns) {
      const chunk = group.slice(i, i + columns);
      rows.push({ type: 'cards', key: `cards-${chunk[0].id}`, items: chunk });
    }
  };
  const splitAt = Math.min(insertAfter, items.length);
  pushCards(items.slice(0, splitAt));
  if (showTopPicksSlot && items.length > 0) rows.push({ type: 'topPicks', key: 'top-picks' });
  pushCards(items.slice(splitAt));
  return rows;
}
